export enum ProfileMenu {
    Collected = 1,
    Activity = 2
}
